import { RentalService } from './../rental.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { globalHelper } from './../../../_helpers/global';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataRowComponent } from '../../_component/pagination-client-side/data-row.component';

@Component({
  selector: 'app-rental-view',
  templateUrl: './rental-view.component.html',
  styleUrls: [
    './rental-view.component.scss',
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class RentalViewComponent implements OnInit, DataRowComponent {

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public rentalServ: RentalService
  ) {
  }

  ngOnInit() {}

  async onClickReservation($event) {

    $event.preventDefault();
    $event.stopPropagation();

    this.actionRequest.emit({
      type: "reservation",
      id: this.row.id,
    });

  }
}
